import React from 'react';
import './Toprectangle.css'; // Optional: add styles here

function Toprectangle() {
  return <div className='rectangle1'></div>
}

export default Toprectangle;
